<vehicle-generic-form [searchName]="searchName" [searchString]="searchString" [isResultsFound]="isResultsFound" (onSubmit)="submit($event)" (onReset)="reset()"></vehicle-generic-form>
<vehicle-generic-results [results]="vehicles" (onVehicleSelected)="vehicleSelected($event)"></vehicle-generic-results>
<div class="well__footer" *ngIf="validationMessage != ''">
	<h2 class="mvd_alert--label">{{validationMessage}}</h2>
	<button class="icon--add btn--default" type="button" *ngIf="showAdd" (click)="addVehicle()">Add New Vehicle</button>
</div>